import React from "react";
import { InputText } from "primereact/inputtext";
import { AppPageHeader } from "components/shared/AppPageHeader";
import { AppButton } from "components/shared/AppButton";
import { SearchInputContainer } from "styles/components/dealersList.styles";
import EcoSaltReportButton from "./EcoSaltReportButton";

interface DealersHeaderProps {
  title: string;
  onAddDealer: () => void;
  addButtonText?: string;
  searchValue?: string;
  onSearchChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  searchPlaceholder?: string;
}

const DealersHeader: React.FC<DealersHeaderProps> = ({
  title,
  onAddDealer,
  addButtonText = "+ Add Dealer",
  searchValue = "",
  onSearchChange,
  searchPlaceholder = "Search dealers...",
}) => {
  return (
    <AppPageHeader title={title}>
      {onSearchChange && (
        <SearchInputContainer>
          <span className="p-input-icon-left">
            <i className="pi pi-search" style={{ marginLeft: 10 }} />
            <InputText
              value={searchValue}
              onChange={onSearchChange}
              placeholder={searchPlaceholder}
              aria-label={searchPlaceholder}
            />
          </span>
        </SearchInputContainer>
      )}
      <EcoSaltReportButton />
      <AppButton type="button" onClick={onAddDealer}>
        {addButtonText}
      </AppButton>
    </AppPageHeader>
  );
};

export default DealersHeader;
